/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Material_Split_ButtonInputs */

const vi_order_material_split_button = /** @type {(inputs: Order_Material_Split_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tách giá vật tư`)
};

/**

* @param {Order_Material_Split_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_material_split_button = /** @type {((inputs?: Order_Material_Split_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Material_Split_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_material_split_button(inputs)
});